var _defs, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiquePorDentro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.4 60.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.5,38.9c-13-20.5-40.2-26.6-60.7-13.6-5.5,3.5-10.1,8.1-13.6,13.6,13,20.5,40.2,26.6,60.7,13.6,2-1.3,3.9-2.7,5.7-4.3M74,41.2c-2.4.6-4.9,0-6.7-1.8-3-3-12.6-15.2-22.5-15.8,0,0,9.1,4.9,9.1,15.4.1,8.5-6.7,15.4-15.2,15.6,0,0-.1,0-.2,0-6.7,0-16-5.1-16-17.3.8-6.1,4.7-11.4,10.4-13.8-9.2,1.9-17.6,6.5-24.2,13.2M48.8,31.6c0,2.5-2.1,4.5-4.6,4.5-2.5,0-4.5-2.1-4.5-4.6,0-2.5,2.1-4.5,4.6-4.5,2.5,0,4.6,2,4.6,4.6,0,0,0,0,0,0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "55.6 11.1 53.2 11.1 53.2 13.5 55.6 13.5 55.6 11.1 55.6 11.1"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "60.5 11.1 58 11.1 58 13.5 60.5 13.5 60.5 11.1 60.5 11.1"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "65.3 11.1 62.9 11.1 62.9 13.5 65.3 13.5 65.3 11.1 65.3 11.1"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "70.2 11.1 67.7 11.1 67.7 13.5 70.2 13.5 70.2 11.1 70.2 11.1"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "55.6 7.3 53.2 7.3 53.2 9.8 55.6 9.8 55.6 7.3 55.6 7.3"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "60.5 7.3 58 7.3 58 9.8 60.5 9.8 60.5 7.3 60.5 7.3"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "65.3 7.3 62.9 7.3 62.9 9.8 65.3 9.8 65.3 7.3 65.3 7.3"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "70.2 7.3 67.7 7.3 67.7 9.8 70.2 9.8 70.2 7.3 70.2 7.3"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "55.6 3.5 53.2 3.5 53.2 6 55.6 6 55.6 3.5 55.6 3.5"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "60.5 3.5 58 3.5 58 6 60.5 6 60.5 3.5 60.5 3.5"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "65.3 3.5 62.9 3.5 62.9 6 65.3 6 65.3 3.5 65.3 3.5"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "70.2 3.5 67.7 3.5 67.7 6 70.2 6 70.2 3.5 70.2 3.5"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "55.6 14.9 53.2 14.9 53.2 17.3 55.6 17.3 55.6 14.9 55.6 14.9"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "60.5 14.9 58 14.9 58 17.3 60.5 17.3 60.5 14.9 60.5 14.9"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "65.3 14.9 62.9 14.9 62.9 17.3 65.3 17.3 65.3 14.9 65.3 14.9"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "70.2 14.9 67.7 14.9 67.7 17.3 70.2 17.3 70.2 14.9 70.2 14.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiquePorDentro);
export default __webpack_public_path__ + "static/media/fique-por-dentro.24629b6084009160179e15ce9169f549.svg";
export { ForwardRef as ReactComponent };